import APIClient from '@/shared/http/clients/api'

const resourceName = 'conta-corrente'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=id,desc`, config)

const contaCorrente = {
  Search
}

export default contaCorrente



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/contacorrente.js